import { useQuery } from '@tanstack/react-query';

import { useFeatureFlag } from '@app/hooks';
import { makeRequest } from '@app/utils';
import { Feature } from '@app/constants';

export const useLCLinkResolverQuery = (instanceId: string) => {
  const { isActive: isLCLinkResolverActive } = useFeatureFlag({
    name: Feature.LCLinkResolver,
  });

  return useQuery(
    ['LCLinkResolver', instanceId],
    () =>
      makeRequest<{ link?: string }>({
        url: '/opac-tools/link-resolver',
        params: {
          type: 'ebsco',
          instanceId,
        },
      }),
    { enabled: isLCLinkResolverActive, select: data => data.link }
  );
};
